import { authRoute, forgotPasswordRoute, resetPasswordRoute, signinRoute } from "@/pages/auth/route";
import type { RouteRecordRaw } from "vue-router";

export const authRoutes: RouteRecordRaw = {
    path: "/auth",
    component: () => import("@/layouts/main.vue"),
    meta: { onlyGuest: true },
    children: [
        authRoute(),
        signinRoute(),
        forgotPasswordRoute(),
        resetPasswordRoute(),
    ],
}; 